module.exports = __webpack_public_path__ + "assets/img/yutou_310_4.48aa956d.jpg";